import React from "react";
import "./Footer.css";

const Footer = () => (

  <div className="d-flex justify-content-center" id="footer">
    <div>© 2019 Auntie Hotmess</div>
    {/* <div>Web Development by Nicholas Chan</div> */}
  </div>

);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js